export const AppConstants = {
    TIME_TO_TURN_IN: 180
}
export const ObveznaLiga = {
    1: 'Liga 5. razred',
    2: 'Liga 6. razred',
    3: 'Liga 7. razred',
    4: 'Liga 8. razred',
    5: 'Liga 1. srednje',
    6: 'Liga 2. srednje',
    7: 'Liga 3. srednje',
    8: 'Liga 4. srednje',
    9: 'Liga Odrasli',
    10: 'Liga Fakultet'
}
